import { useMemo } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { checkIf, getUserRole, UserRoles } from "../../utils";
import { useMediaQuery } from "@react-hook/media-query";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import MobileIndex from "../../pages/MobileIndex";
import Index from "../../pages/Index";
import Homepage from "../../pages/Homepage";
import WelcomeOnboarding from "../WelcomeOnboarding";
import { getTenant } from "../../theme";

export default function NavigationPlan() {
  const mobile = useMediaQuery("only screen and (max-width: 600px)");
  const user = useSelector((state: RootState) => state.user);
  const [searchParams] = useSearchParams();
  const invitationCode = searchParams.get("code");
  const tenant = getTenant();

  const userRole = useMemo(() => {
    return getUserRole(user);
  }, [user]);

  const isAuthenticated = userRole !== UserRoles.ANONYMOUS;

  if (checkIf(invitationCode) && userRole !== UserRoles.ANONYMOUS) {
    return (
      <Navigate
        to={{
          pathname: "/inv/" + invitationCode,
        }}
      />
    );
  } else if (isAuthenticated) {
    // For rejeem tenant, show Homepage component
    if (tenant.name === "rejeem") {
      return <Homepage />;
    }

    // All other authenticated users redirect to meal-plan
    return <Navigate to="/meal-plan" />;
  }

  // For non-authenticated users
  if (mobile) {
    // Rejeem gets the new immersive welcome flow; other tenants keep the legacy carousel.
    return tenant.name === "rejeem" ? <WelcomeOnboarding /> : <MobileIndex />;
  }
  return tenant.name === "rejeem" ? <Homepage /> : <Index />;
}
